import React from 'react';
import './App.css';
import { BrowserRouter } from 'react-router-dom';
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import BrandStrip from './components/BrandStrip';
import ThesisSection from './components/ThesisSection';
import CriteriaSection from './components/CriteriaSection';
import ProcessSection from './components/ProcessSection';
import FAQSection from './components/FAQSection';
import ContactSection from './components/CTASection';
import Footer from './components/Footer';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navigation />
        <HeroSection />
        <BrandStrip />
        <ThesisSection />
        <CriteriaSection />
        <ProcessSection />
        <FAQSection />
        <ContactSection />
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;